module.exports = __webpack_public_path__ + "img/introductionpic.530fd302.png";